import { NavActionButton } from 'src/features/Navbar/NavActionButton/NavActionButton';
import { NavItem } from 'src/features/Navbar/NavItem';
import { UserRecentFeature } from 'src/generated/graphql';
import { UserRecent } from 'src/hooks/recents';
import { useLocales } from 'src/locales';
import { useTodoDetailsModal } from 'src/pages/dashboard/TodosPage/TodoContent/TodoDetails';
import { useBoardTableRowDialog } from 'src/sections/@dashboard/board/BoardTableRowDialog';
import {
  titleByUrl,
  useRecentRegister,
} from 'src/sections/@dashboard/recents/shared';
import { NavRecentItemIcon } from './NavRecentItemIcon';

type NavRecentItemProps = {
  recent: UserRecent;
};

const hasModals = [UserRecentFeature.BoardRow, UserRecentFeature.TodoItem];

export const NavRecentItem = ({ recent }: NavRecentItemProps) => {
  const { translate } = useLocales();
  const { removeRecent } = useRecentRegister();
  const { showBoardTableRowDialog } = useBoardTableRowDialog();
  const { showTodoDetailsModal } = useTodoDetailsModal();

  const handleOpenTableRow = () => {
    const params = recent.url.split('/');
    showBoardTableRowDialog({
      viewId: '',
      boardId: params?.[3],
      tableId: params?.[4],
      rowId: recent.objectRef || '',
    });
  };

  const handleOpenTodoItem = () => {
    showTodoDetailsModal({ todoId: recent.objectRef || '' });
  };

  const handleOpenModal = (e: any) => {
    if (hasModals.includes(recent.feature)) {
      e.stopPropagation();
      e.preventDefault();
      if (recent.feature === UserRecentFeature.BoardRow)
        return handleOpenTableRow();
      if (recent.feature === UserRecentFeature.TodoItem)
        return handleOpenTodoItem();
    }
  };

  return (
    <>
      <NavItem
        key={recent._id}
        path={recent.url}
        depth={1}
        icon={<NavRecentItemIcon recent={recent} />}
        onClick={handleOpenModal}
        action={
          <NavActionButton
            icon="ic:round-close"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              removeRecent(recent._id);
            }}
            size={16}
            color="default"
          />
        }
      >
        {recent.title || translate(titleByUrl[recent.url])}
      </NavItem>
    </>
  );
};
